import { FormEventHandler, useState } from 'react'
import styled from 'styled-components'
import { Title } from 'react-head'
import { Button } from '@bm-js/atlascloud-ui'
import MinimalNav from '../components/MinimalNav'
import { colors, measurments } from '../utils/config'
import Input from '../components/Input'
import { fetcher } from '../utils/fetcher'
import { ChangeEvent } from '@bm-js/atlascloud-shared'

const StyledForgotPassword = styled.div`
  .content {
    padding-top: 4rem;
    padding-bottom: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 8rem);
    form,
    .card {
      width: 48ch;
      background: white;
      padding: 3.2rem 4.5rem;
      border-radius: ${measurments.borderRadiusLarge}px;
      box-shadow: 0px 32px 64px -12px rgba(16, 24, 40, 0.2);
      h1 {
        font-weight: 700;
        font-size: 40px;
        line-height: 48px;
        letter-spacing: -2%;
        color: ${colors.primary400};
      }
    }
  }
  .error {
    text-align: center;
    color: ${colors.error400};
  }
`

const ForgotPassword = () => {
  //Static
  const initialUser = {
    email: '',
  }

  //States
  const [formData, setFormData] = useState(initialUser)
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [finished, setFinished] = useState(false)

  //Functions
  const handleChange = (e: ChangeEvent) => {
    setErrorMessage('')
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmit: FormEventHandler = async (e) => {
    e.preventDefault()
    setLoading(true)
    const { err } = await fetcher({
      path: 'customer-no-auth/request-password-reset',
      method: 'POST',
      body: formData,
    })
    if (err) {
      setErrorMessage('Något gick fel')
      setLoading(false)
      return
    }
    setFinished(true)
    setLoading(false)
  }

  return (
    <StyledForgotPassword>
      <Title>Glömt lösenord | Atlascloud</Title>
      <MinimalNav />
      {finished ? (
        <div className='content'>
          <div className='card'>
            <h1 className='m0 mbottom2'>Färdigt!</h1>
            <p className='m0'>
              Om mailadressen du angav var korrekt så har nu ett mail skickats
              till dig från noreply@bucketmedia.se. Via länken i mailet kan du
              återställa ditt lösenord. Länken är giltig i 24 timmar.
              <br />
              Titta i skräpposten om du inte hittar något mail.
              <br />
              <br />
              Det går bra att stänga denna flik nu.
            </p>
          </div>
        </div>
      ) : (
        <div className='content'>
          <form onSubmit={handleSubmit}>
            <h1 className='m0 mbottom05'>Glömt lösenord?</h1>
            <p className='m0 mbottom1'>
              Skriv in din mailadress och tryck på skicka så skickar vi en
              återställningslänk till dig.
            </p>
            <Input
              required
              disabled={loading}
              label='Mailadress'
              type='email'
              value={formData.email}
              placeholder='exempel@mail.com'
              name='email'
              onChange={handleChange}
            />
            <div className='jce flex'>
              <Button type='submit' disabled={loading}>
                {loading ? 'Skickar...' : 'Skicka'}
              </Button>
            </div>
            {errorMessage && <p className='m0 mtop1 error'>{errorMessage}</p>}
          </form>
        </div>
      )}
    </StyledForgotPassword>
  )
}

export default ForgotPassword
